<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 分配功能权限
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <el-form :inline="true" label-width="120px">
                <el-form-item label="角色名称:">
                    <span>{{roleName}}</span>
                </el-form-item>
            </el-form>

        </div>
        <div class="container">
            <tree-transfer
                    :button_text="['添加','取消']"
                    ref="treeTransfer"
                    v-if="refreshTree"
                    :title="transferTitle"
                    :from_data="noSelectData"
                    :to_data="selectedData"
                    :defaultProps="defaultProps"
                    @add-btn="add"
                    @remove-btn="remove"
                    openAll
                    filter
                    height="400px"
                    :mode="mode"
                    :node_key="nodeKey"
                    :pid="parentId"
            ></tree-transfer>
        </div>
    </div>
</template>

<script>
    import Api from '../../api/authority/index'
    import TreeTransfer from 'el-tree-transfer'
    export default {
        name: "assignFunctionAuth",
        components: {
            TreeTransfer
        },
        props: {
            node_key:{
                type:String,
                default:'authId'
            },
            pid:{
                type:String,
                default:'parentAuthId'
            }
        },
        data() {
            return {
                noSelectData:[],
                selectedData:[],
               roleName:this.$route.query.roleName,
                transferTitle:['功能权限',   '已选功能权限'],
                parentId:'parentAuthId',
                nodeKey:'authId',
                mode:'transfer',
                defaultProps:{
                    label: 'authName',
                    children: 'childList',
                    disabled: 'flag'
                },
                authIdList:[],
                refreshTree:true
            }
        },
        computed: {},
        created() {
            this.getDataAuth()
            this.checkDataAuth()
        },
        methods: {
            getDataAuth(){
                let params = {
                    isBack: false,
                    roleId: this.$route.query.roleId
                }
                Api.queryDataAuth(params)
                    .then((res) => {
                        if(res.code == '200'){
                            this.noSelectData.push(res.data)
                        }
                    })
            },
            checkDataAuth(){
                let params = {
                    roleId: this.$route.query.roleId
                }
                Api.checkDataAuth(params)
                    .then((res) => {
                        this.selectedData.push(res.data)
                    })
            },
            add(fromData, toData){
                this.authIdList = []
             this.formAuthIdList(toData)
                let params = {
                    roleId: this.$route.query.roleId,
                    authIdList: this.authIdList
                }
                Api.addDataAuth(params)
                    .then((res) => {
                        if(res.code == '200'){
                            this.$message({
                                type:'success',
                                message:'新增权限成功'
                            })
                            this.noSelectData = []
                            setTimeout(() => {
                                //查询树的数据
                                this.getDataAuth();
                                //<el-tree>组件使用v-if重新加载
                                this.refreshTree = false
                                this.$refs.treeTransfer.$nextTick(() => {
                                    this.refreshTree = true;
                                })
                            }, 100);
                        }
                    })
            },
            remove(fromData, toData){
                this.authIdList = []
                this.formAuthIdList(toData)
                let params = {
                    roleId: this.$route.query.roleId,
                    authIdList: this.authIdList
                }
                Api.addDataAuth(params)
                    .then((res) => {
                        if(res.code == '200'){

                            this.$message({
                                type:'success',
                                message:'删除权限成功'
                            })
                            this.noSelectData = []
                            setTimeout(() => {
                                //查询树的数据
                                this.getDataAuth();
                                //<el-tree>组件使用v-if重新加载
                                this.refreshTree = false
                                this.$refs.treeTransfer.$nextTick(() => {
                                    this.refreshTree = true;
                                })
                            }, 100);
                        }
                        // this.getDataAuth()
                    })
            },
            formAuthIdList(toData){
                for(let i in toData){
                    this.authIdList.push(toData[i].authId)
                    if(toData[i].childList){
                        this.formAuthIdList(toData[i].childList);
                    }
                }
            },
            disabledNode(data){
                this.authIdList = []
               this.formAuthIdList(this.selectedData)
                this.authIdList.forEach((item,index) => {
                    return data.authId === item[index]
                })
            }
        }

    }
</script>

<style scoped>

</style>
